<template>
  <Modal width="1020" v-model="show" :mask-closable="false"  :loading="loading">
      <div slot="header" class="modal-header">添加房源</div>
      <Form :model="formData" :label-width="85" :rules="formRules" ref="formValidate">
        <Row :gutter="16">
          <Col :span="8">
            <FormItem label="项目名称" prop="projectFid">
              <Select v-model="formData.projectFid" @on-change="changeProject">
                <Option value="">请选择</Option>
                  <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="8" >
            <FormItem label="楼栋" prop="buildingId">
                <Select v-model="formData.buildingId" @on-change="changeBuilding">
                  <Option value="">{{ formData.projectFid===''? '请先选择项目':(buildingList.length!==0 ?'请选择':'暂无数据')}}</Option>
                  <Option v-for="item in buildingList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </FormItem>
          </Col> 
          <Col :span="8">
            <FormItem label="楼层" prop="houseFloorNumber">
                <Select v-model="formData.houseFloorNumber">
                  <Option value="">{{ formData.buildingId===''? '请先选择楼栋':(floorList.length!==0 ?'请选择':'暂无数据')}}</Option>
                  <Option v-for="item in floorList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col :span="8">
            <FormItem label="房源编号" prop="houseNumber">
                <Input v-model="formData.houseNumber" ></Input>
            </FormItem>
          </Col>
          <Col :span="8" >
            <FormItem label="房型名称" prop="houseTypeId">
                <Select v-model="formData.houseTypeId" >
                  <Option value="">{{ formData.projectFid===''? '请先选择项目':(buildingList.length!==0 ?'请选择':'暂无数据')}}</Option>
                    <Option v-for="item in houseTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </FormItem>
          </Col>
          <Col :span="8">
            <FormItem label="床类型" prop="houseBedType">
              <Select v-model="formData.houseBedType">
                <Option value="">请选择</Option>
                  <Option v-for="item in houseBedTypeEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col :span="8">
            <FormItem label="装修风格" prop="houseDecorationstyle">
                <Select v-model="formData.houseDecorationstyle" >
                  <Option value="">请选择</Option>
                    <Option v-for="item in houseDecorationStyleEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </FormItem>
          </Col>
          <Col :span="8">
            <FormItem label="面积" prop="houseArea">
              <Input v-model="formData.houseArea" :number="true">
              <span slot="append">㎡</span>
              </Input>
            </FormItem> 
          </Col>
          <Col :span="8">
          <FormItem label="朝向" prop="houseDirection">
            <Select v-model="formData.houseDirection">
                <Option value="">请选择</Option>
                <Option v-for="item in directionHouseEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
        </FormItem>
        </Col>
        </Row>
        <Row :gutter="16">
          <Col :span="8">
            <FormItem class="date-picker" label="最晚签约日" prop="houseMaxsigndate">
              <DatePicker ref="houseMaxsigndate" type="date"  v-model="formData.houseMaxsigndate" @on-change="formData.houseMaxsigndate=$event" placeholder="yyyy-mm-dd" ></DatePicker>
            </FormItem> 
          </Col>
        <Col :span="8">
          <FormItem label="出租类型" prop="houseRentType">
            <Select v-model="formData.houseRentType">
              <Option value="">请选择</Option>
                <Option v-for="item in houseRentTypeEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>

        <Col v-if="formData.houseRentType===0" :span="8" >
          <FormItem label="出租价格" prop="houseRentPrice">
            <Input v-model="formData.houseRentPrice" :number="true">
            <span slot="append">元／月</span>
            </Input>
          </FormItem>
        </Col> 
        <Col :span="8" v-if="formData.houseRentType===1">
           <Button type="primary" size="small" style="margin-top:5px" @click="addRoom">添加房间／床位</Button>
        </Col>
        </Row>
        
        <div v-if="formData.houseRentType===0&&show">
          <long-term-set-price ref="houseRentType0LongTermPrice"></long-term-set-price>
        </div>

        <div v-if="formData.houseRentType===1&&show">
          <add-room-format :isUpdate="isUpdate" :stockStatusEnums="stockStatusEnums" :directionHouseEnums="directionHouseEnums" :stockTypeEnums="stockTypeEnums" :ref="`form${i}`" v-if="item.status === 1" style="flex:1" v-for = "(item,i) in formDynamic" :index="i" :key="`form${i}`" @delete-item="deleteItem"></add-room-format>
        </div>  
        <Row :gutter="16">
          <Col :span="8">
            <FormItem label="业主名称" prop="ownerId">
              <Select v-model="formData.ownerId" filterable>
                <Option value="">请选择</Option>
                <Option v-for="item in projectOwnerList" :value="item.fid" :key="item.fid">{{item.name}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>

        <FormItem label="备注" prop="remark">
          <Input v-model="formData.remark" type="textarea" :rows="4" ></Input>
        </FormItem>
      </Form>

      <div slot="footer">
        <Button type="text" size="large" @click="handleCancel">取消</Button>
        <Button type="primary" size="large" @click="save" :loading="loading">
          <span v-if="!loading">保存</span>
          <span v-else>保存中...</span>
        </Button>
      </div>
    </Modal>
  
</template>
 
<script type="text/ecmascript-6">
import {formatDateTime} from "@/utils/format";
import AddRoomFormat from './AddRoomFormat';
import {  getHouseType, getSelectData, addStock, getMaxsigndate } from "api/house"
import LongTermSetPrice from './components/LongTermSetPrice';
export default {
  props: {
    n: {
      type: Number,
      default: 0
    },
   
    stockStatusEnums:{
      type:Array,
      default:[]
    },
    projectList:{
       type:Array,
      default:[]
    },
    projectOwnerList:{
      type:Array,
      default(){
        return []
      }
    },
  },
  created(){
    this.initCondition()
  },
  watch: {
		n() {
      this.$refs['formValidate'].resetFields();
      this.formData.ownerId = ''
      // console.log(this.formData.subRoomList)
			this.loading = false
      this.show = true;
      this.index = 0
      this.formDynamic = [ {index:0,status: 1} ]
    }
  },
  components:{
    AddRoomFormat,
    LongTermSetPrice
  },
  data () {
    const validateDate = (rules,value,callback)=>{
      rules.type = typeof value === 'object' ? 'object':'string'
      if(!value){
        callback(new Error('请选择最大签约到期时间'));
      }
      callback();
    }
    const validateNum = (rule, value, callback) => {  
      if(!value || typeof value === 'string' || value <= 0){
        callback(new Error('请输入大于0的数字'));
      }
      callback();
    }
    return {
      isUpdate:false,
      index:0,
      formDynamic:[{
        index:0,
        status: 1
      }],
      roomCount:1,
      show:false,
      loading:false,
  
      buildingList:[],
      houseTypeList:[],
      floorList:[],
      houseBedTypeEnums:[],
      houseDecorationStyleEnums:[],
      houseRentTypeEnums:[],
      directionHouseEnums:[],
      formData: {    
        buildingId: "",
        houseArea: "",
        houseBedType: "",
        houseDecorationstyle: "",
        houseDirection: "",
        houseFloorNumber: "",
        houseMaxsigndate: "",
        houseNumber: "",
        houseRentPrice: "",
        houseRentType: "",
        houseStockStatus: "",
        houseTypeId: "",
        ownerId:'',
        projectFid: "",
        stockFid: "",
        subRoomList:[],
        remark:"",
        subRoomList: [],
        discountPriceDtoList:[]
      },
      formRules:{
        projectFid:[{ required: true, type:'string', message:'请选择项目名称', trigger: 'change'}],
        buildingId:[{ required: true, type:'string', message:'请选择楼栋', trigger: 'change'}],
        houseFloorNumber:[{ required: true, type:'number', message:'请选择楼层', trigger: 'change'}],
        houseTypeId:[{ required: true, type:'string', message:'请选择房型名称', trigger: 'change'}],
        houseNumber:[{ required: true, type:'string', message:'请输入房源编号', trigger: 'blur'}],
        houseBedType:[{ required: true, type:'number', message:'请选择床类型', trigger: 'change'}],
        houseDecorationstyle:[{ required: true, type:'number', message:'请选择装修风格', trigger: 'change'}],
        // houseMaxsigndate: [{ required: true, validator: validateDate, trigger:'change'}],
        houseRentType:[{ required: true, type:'number',message:'请选出租类型',trigger: 'change'}],
        houseArea:[{ required: true, validator: validateNum, trigger: 'blur'}],
        houseDirection:[{ required: true, type:'number', message:'请选择朝向', trigger: 'change'}],
        houseRentPrice:[{ required: true, validator: validateNum, trigger: 'blur'}]
			},
    };
  },
  methods:{
    addRoom(){
      this.index++
      this.formDynamic.push({
        index:this.index,
        status:1
      })
    },
    changeProject(value){
      if(!value){
        this.buildingList=[]
        this.floorList =[]
        this.houseTypeList=[]
        this.formData.houseMaxsigndate=""
        return
      }
      for (let [index, item] of this.projectList.entries()) {
        if (value === item.value) {       
          this.buildingList = this.projectList[index].children;
        }
      }
      getHouseType(value).then(res => {
        this.houseTypeList = res.data.houseTypeList
      })
      getMaxsigndate(value).then(res => {
        this.formData.houseMaxsigndate = res.data
      })
    },
    changeBuilding(value){
      if(!value){
        this.floorList =[]
        return
      }
      for (let [index, item] of this.buildingList.entries()) {
        if (value === item.value) {       
          this.floorList = this.buildingList[index].children;
        }
      }    
    },
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
    },
     deleteItem(data){
      let index = data.index
      
        this.formDynamic[index].status = 0
    
      
    },
    getDateExp(ref) {
      if(typeof this.formData[ref]==='object'){
        this.formData[ref] = this.$refs[ref].publicStringValue
      }
    },
    handleCancel(){
      this.show = false
    },
    initCondition(){
      getSelectData().then( res => {
       this.stockTypeEnums = res.data.stockTypeEnums
       this.houseDecorationStyleEnums = res.data.houseDecorationStyleEnums
       this.houseRentTypeEnums = res.data.houseRentTypeEnums
       this.directionHouseEnums = res.data.directionHouseEnums
       this.houseBedTypeEnums = res.data.houseBedTypeEnums
      })
    },
    validateSubRoomList(){
      let formList = this.formDynamic.filter( item => {
        return item.status === 1
      }) 
      let subRoomList = []
      let result = formList.every( item => {
        // console.log(this.$refs[`form${item.index}`][0].formValidate())   
        subRoomList.push(this.$refs[`form${item.index}`][0].formValidate())
        return this.$refs[`form${item.index}`][0].formValidate()
      })
      if(result) {
       return subRoomList
      }else{
        return false
      }
    },
    save() {
      let data = null
      this.$refs['formValidate'].validate( bool => {
        if(bool){
         
          if(this.formData.houseRentType===0){
            if(!this.$refs.houseRentType0LongTermPrice.validateSubmit()) return;
            this.formData.discountPriceDtoList = this.$refs.houseRentType0LongTermPrice.submitDiscountPriceDtoList()

            if(typeof this.formData.houseMaxsigndate === 'object'){
              this.formData.houseMaxsigndate = formatDateTime(this.formData.houseMaxsigndate,false)
            }
            this.loading = true
            addStock(this.formData).then(res => {
            // console.log(res.data)
              this.loading = false
              this.$Message.success('新建房源成功'); 
              this.$emit('refresh')
              this.show=false
            }).catch( res => {
              this.loading=false
            })
          }else{ // 合租类型
            this.formData.subRoomList = this.validateSubRoomList()
            if(!this.formData.subRoomList) return
            this.loading = true
            addStock(this.formData).then(res => {
              this.loading = false
              this.$Message.success('新建房源成功');
              // this.changeLoading()
              this.$emit('refresh')
              this.show=false
            }).catch( res => {
              this.loading=false
            })
            
           
          }
        }else{
         // console.log('false')
       // this.changeLoading()
        return
        }
      });
    }
  }
  
}
</script>
